import { Dispatch, JSX, SetStateAction, useContext, useMemo } from "react";
import Carousel from "./_components/carousel";
import SalesDropDown from "./_components/sales-drop-down";
import { SalesBreakdownData, SalesOverviewOptions } from "@/app/types/types";
import { UserContext } from "@/app/_components/context/user-context";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface SalesBreakDownProps {
  loading: boolean;
  salesData: SalesBreakdownData;
  salesChart: JSX.Element;
  frontGrossChart: JSX.Element | undefined;
  backGrossChart: JSX.Element | undefined;
  selectedSalesOverviewOption: SalesOverviewOptions;
  setSelectedSalesOverviewOption: Dispatch<
    SetStateAction<SalesOverviewOptions>
  >;
}

export default function SalesBreakDown({
  loading,
  salesData,
  salesChart,
  frontGrossChart,
  backGrossChart,
  selectedSalesOverviewOption,
  setSelectedSalesOverviewOption,
}: SalesBreakDownProps) {
  const { user } = useContext(UserContext);

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-semibold">
            {`Welcome${user ? ", " + user.name : ""}`}
          </CardTitle>
          <SalesDropDown
            selectedSalesOverviewOption={selectedSalesOverviewOption}
            setSelectedSalesOverviewOption={setSelectedSalesOverviewOption}
          />
        </div>
      </CardHeader>
      <CardContent className="pb-3">
        <Carousel
          loading={loading}
          salesData={salesData}
          salesChart={salesChart}
          frontGrossChart={frontGrossChart}
          backGrossChart={backGrossChart}
        />
      </CardContent>
    </Card>
  );
}
